import React, { useState } from 'react';
import { HiChevronDown, HiOutlineBeaker, HiOutlineRefresh } from 'react-icons/hi';
import TextEdit from '../../../../../molecules/TextEdit';
import { TemplateVariable } from '../../../../../../types/communication';

interface TestValuesProps {
    variables: TemplateVariable[];
    values: Record<string, string>;
    onChange: (name: string, value: string) => void;
    onReset: () => void;
}

const TestValues: React.FC<TestValuesProps> = ({ variables, values, onChange, onReset }) => {
    const [open, setOpen] = useState(false);
    if (!variables.length) return null;
    return (
        <div className="rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800">
            <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-4 py-3 text-left">
                <HiOutlineBeaker className="text-teal-600 dark:text-teal-300" size={18} />
                <span className="flex-1">
                    <span className="block text-sm font-semibold text-gray-800 dark:text-gray-100">Valores de teste</span>
                    <span className="block text-[11px] text-gray-400">Troque os exemplos para ver como fica cada caso</span>
                </span>
                <HiChevronDown className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} size={18} />
            </button>
            {open && (
                <div className="px-4 pb-4">
                    <div className="flex flex-col gap-4 max-h-80 overflow-y-auto pr-1 pt-2">
                        {variables.map((v) => (
                            <TextEdit
                                key={v.name}
                                id={`test-value-${v.name}`}
                                label={v.label}
                                value={values[v.name] ?? ''}
                                onChange={(e) => onChange(v.name, e.target.value)}
                            />
                        ))}
                    </div>
                    <button
                        type="button"
                        onClick={onReset}
                        className="mt-3 inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-800 dark:hover:text-gray-200"
                    >
                        <HiOutlineRefresh size={14} /> Restaurar exemplos
                    </button>
                </div>
            )}
        </div>
    );
};

export default TestValues;
